
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactApi, reactElement } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { createObj } from "../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Button, TextButton } from "./Button.js";
import Arrow_Left_1 from "../../public/assets/icons/Arrow_Left_1.svg";
import { ofArray } from "../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { PageHeader } from "./Text.js";
import { singleton, append, delay, toList } from "../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { defaultArg } from "../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";

export function FormContainer(props) {
    let elems_3, elems, Label, elems_2;
    const t = useTranslation()[0];
    const componentState = props.FormState.IsLoading ? "disabled" : "enabled";
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "max-w-5xl"])], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["mb-5"])], (elems = [createElement(TextButton, (Label = t("general.back"), {
        ComponentState: componentState,
        Icon: Arrow_Left_1(),
        Label: Label,
        OnClick: props.OnBack,
        TestId: "form-on-back-button",
        Variant: "default",
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(PageHeader, {
        Text: props.Header,
    }), reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-5"])], (elems_2 = toList(delay(() => append(props.Children, delay(() => {
        let elems_1, Label_1, OnClick_1;
        return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-end"])], (elems_1 = [createElement(Button, (Label_1 = t("general.save"), (OnClick_1 = defaultArg(props.OnSave, () => {
        }), {
            ComponentState: (props.OnSave == null) ? "disabled" : componentState,
            Label: Label_1,
            OnClick: OnClick_1,
            TestId: "submit-form-button",
            Variant: "primary",
        })))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])));
}

